import { UnsupportedError } from '@errors';
import { getChainInfo } from '@lib/cronos-chain';
import { CronosChain, EthChainId } from '@types';
import { AbiItem } from 'web3-utils';

var contract = require('web3-eth-contract');

const getWeb3Contract = (
  abi: AbiItem[],
  address: string | undefined,
  chain: EthChainId
) => {
  switch (chain) {
    case EthChainId.Mainnet:
      contract.setProvider(getChainInfo(EthChainId.Mainnet).rpcUrls[0]);
      break;
    case EthChainId.Kovan:
      contract.setProvider(getChainInfo(EthChainId.Kovan).rpcUrls[0]);
      break;
    case EthChainId.Goerli:
      contract.setProvider(getChainInfo(EthChainId.Goerli).rpcUrls[0]);
      break;
    case EthChainId.Cronos:
      contract.setProvider(getChainInfo(EthChainId.Cronos).rpcUrls[0]);
      break;
    case EthChainId.CronosTestnet:
      contract.setProvider(getChainInfo(EthChainId.CronosTestnet).rpcUrls[0]);
      break;
    case EthChainId.CronosGravityTestnet:
      contract.setProvider(
        getChainInfo(EthChainId.CronosGravityTestnet).rpcUrls[0]
      );
      break;
    default:
      throw new UnsupportedError(chain?.toString());
  }
  return new contract(abi, address);
};

export default getWeb3Contract;
